// Labels for the fields CHAMP adds on top of Atomic CRM (hand-written;
// the re-worded upstream labels live in the generated champMessages.ts).
export const champDomainMessages = {
  resources: {
    contacts: {
      roles: {
        guardian: "Guardian",
        player: "Player",
      },
      roles_plural: {
        guardian: "Guardians",
        player: "Players",
      },
      age_short: "%{smart_count} yr |||| %{smart_count} yrs",
      field_categories: {
        player: "Player",
      },
      fields: {
        role: "Role",
        date_of_birth: "Date of birth",
        medical_notes: "Medical notes",
        coach_notes: "Notes for the coach",
      },
      helpers: {
        medical_notes:
          "Allergies, asthma, medication. Shown in red on the roster.",
        coach_notes:
          'What the coach should know, e.g. "a little shy at first".',
      },
      player_age:
        "%{smart_count} year old (born %{date}) |||| %{smart_count} years old (born %{date})",
    },
    deals: {
      fields: {
        class_id: "Class",
        player_id: "Player",
        guardian_id: "Guardian",
        paid: "Paid",
        source: "Source",
        category: "Type",
        amount: "Amount ($)",
        expected_closing_date: "Start date",
      },
      sources: {
        acuity: "Acuity",
        manual: "Added by hand",
        "walk-in": "Walk-in",
      },
      paid: "Paid",
      unpaid: "Unpaid",
      no_class: "No class linked",
      autocomplete: {
        create_player: "Add player %{item}",
        create_guardian: "Add guardian %{item}",
        create_label: "Start typing a name to add someone new",
        pick_family_first: "Pick the family first, then add the person.",
        create_error: "Could not add that person.",
      },
    },
  },
};
